<template>
  <master-main
    :route="getModuleRoute"
    :addProperties="{
      eventType: 1,
      routeToCreate: getModuleRoute,
    }"
    :tableProperties="tableProperties"
    :exportProperties="{
      pdf: {
        filename: `${$t('common_words.group_of_activities')}.pdf`,
        route: `${getModuleRoute}/pdf`,
      },
      xls: {
        filename: `${$t('common_words.group_of_activities')}.xlsx`,
        route: `${getModuleRoute}/excel`,
      },
    }"
    :dataBadges="[
      {
        columnLabel: $t('common_words.activities'),
        data: 'activities',
        property: 'name',
        minWidth: 300,
      },
      {
        columnLabel: $t('common_words.associated_companies2'),
        data: 'businesses',
        property: 'name',
        minWidth: 200,
      },
    ]"
    :showProperties="showProperties"
    @showHideLoading="showHideLoading"
    @showNotification="notifyVue"
    @refresh="refresh"
  ></master-main>
</template>
<script>
import GroupTable from './activities-groups-table';
import i18n from 'src/i18n';
import MasterMain from 'src/components/Layouts/Masters/MasterMain.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMain from 'src/mixins/master/mixin-main';
import MixinPermissions from 'src/util/mixinPermissions';

export default {
  components: { MasterMain },
  data() {
    return {
      tableProperties: {},
      showProperties: { size: '80%' },
    };
  },
  computed: {
    getModuleRoute() {
      return 'works/activitiesgroups';
    },
    buildTableProperties() {
      return {
        tableColumns: [...GroupTable().tableColumns],
        effectTags: 'dark',
        model: 'activitygroup',
        addColumns: [
          {
            label: i18n.t('common_words.associated_profiles2'),
            data: 'roles',
            field: 'name',
          },
          {
            label: i18n.t('common_words.registered_users2'),
            data: 'users',
            field: 'username',
          },
        ],
      };
    },
  },
  mixins: [MixinAlert, MixinLoading, MixinMain, MixinPermissions],
};
</script>
